import { CompanyInvoiceStatus, InvoiceProfile } from '@/types/invoiceProfile'

export function isActiveInvoiceProfile(invoiceProfile: InvoiceProfile) {
	return invoiceProfile.status === CompanyInvoiceStatus.Active
}
